import React, { useState } from 'react';
import axios from 'axios';
import './Analyse.css';

const Analyse = () => {
    const [discordId, setDiscordId] = useState('');
    const [result, setResult] = useState('');
    const [evidenceCode, setEvidenceCode] = useState('');
    const [evidenceCodeReadonly, setEvidenceCodeReadonly] = useState(false);
    const [moddingPrograms, setModdingPrograms] = useState('');
    const [comment, setComment] = useState('');
    const [recordingObligation, setRecordingObligation] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [loading, setLoading] = useState(false);

    const API_BASE = process.env.REACT_APP_API_BASE;
    const RECORDING_ROLE_ID = process.env.REACT_APP_RECORDING_ROLE_ID;

    const loadRecord = async (id) => {
        try {
            const token = localStorage.getItem('discord_token');
            const response = await axios.get(`${API_BASE}/api/analysis/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data && response.data.length > 0) {
                const record = response.data[0];
                setResult(record.result || '');
                setModdingPrograms(record.modding_programs || '');
                setEvidenceCode(record.evidence_link || '');
                setEvidenceCodeReadonly(!!record.evidence_link);
                setComment(record.comment || '');
                setRecordingObligation(record.recording_obligation === 1);
            }
        } catch (error) {
            console.error('Error loading record:', error);
        }
    };

    const resetForm = () => {
        setResult('');
        setModdingPrograms('');
        setEvidenceCode('');
        setEvidenceCodeReadonly(false);
        setComment('');
        setRecordingObligation(false);
    };

    const handleDiscordIdChange = (e) => {
        const value = e.target.value;
        setDiscordId(value);
        if (value.length < 17) {
            resetForm();
        } else {
            loadRecord(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!discordId || !result) {
            setMessage('Fehlende Daten: ID oder Ergebnis.');
            setMessageType('danger');
            return;
        }
        setLoading(true);
        try {
            const token = localStorage.getItem('discord_token');
            const userResponse = await axios.get('https://discord.com/api/users/@me', {
                headers: { Authorization: `Bearer ${token}` }
            });
            const analystId = userResponse.data.id;

            const data = {
                discordId, analystId, result,
                moddingPrograms: moddingPrograms || undefined,
                evidenceLink: evidenceCode,
                evidenceLink2: '',
                evidenceLink3: '',
                comment,
                recordingObligation: recordingObligation ? 1 : 0
            };

            await axios.post(`${API_BASE}/api/analysis`, data, { headers: { Authorization: `Bearer ${token}` } });

            await axios.post(`${API_BASE}/api/analyse-log`, {
                discordUserID: discordId, result,
                moddingPrograms: moddingPrograms || undefined,
                evidenceLinks: evidenceCode ? [evidenceCode] : [],
                comment,
                recordingObligation: recordingObligation ? 1 : 0,
                analystTag: userResponse.data.username,
                analystDiscordID: analystId
            }, { headers: { Authorization: `Bearer ${token}` } });

            if (recordingObligation) {
                try {
                    await axios.post(`${API_BASE}/api/assign-role`, { userId: discordId, roleId: RECORDING_ROLE_ID }, { headers: { Authorization: `Bearer ${token}` } });
                } catch (e) { console.error(e); }
            } else {
                try {
                    await axios.post(`${API_BASE}/api/remove-role`, { userId: discordId, roleId: RECORDING_ROLE_ID }, { headers: { Authorization: `Bearer ${token}` } });
                } catch (e) { console.error(e); }
            }

            if (result === 'accepted') {
                const WHITELIST_SUCCESS_ROLE_ID = process.env.REACT_APP_WHITELIST_SUCCESS_ROLE_ID;
                try {
                    await axios.post(`${API_BASE}/api/assign-role`, { userId: discordId, roleId: WHITELIST_SUCCESS_ROLE_ID }, { headers: { Authorization: `Bearer ${token}` } });
                } catch (e) { console.error(e); }
            }

            if (result === 'modding') {
                const WHITELIST_SUCCESS_ROLE_ID = process.env.REACT_APP_WHITELIST_SUCCESS_ROLE_ID;
                const WHITELIST_ROLE_ID = process.env.REACT_APP_WHITELIST_ROLE_ID;
                const MODDING_ADD_ROLE_ID = process.env.REACT_APP_MODDING_ADD_ROLE_ID;
                try {
                    await axios.post(`${API_BASE}/api/remove-role`, { userId: discordId, roleId: WHITELIST_SUCCESS_ROLE_ID }, { headers: { Authorization: `Bearer ${token}` } });
                } catch (e) { console.error(e); }
                try {
                    await axios.post(`${API_BASE}/api/remove-role`, { userId: discordId, roleId: WHITELIST_ROLE_ID }, { headers: { Authorization: `Bearer ${token}` } });
                } catch (e) { console.error(e); }
                try {
                    await axios.post(`${API_BASE}/api/assign-role`, { userId: discordId, roleId: MODDING_ADD_ROLE_ID }, { headers: { Authorization: `Bearer ${token}` } });
                } catch (e) { console.error(e); }
            }

            setMessage('Deine Eingabe wurde im Discord gepostet !');
            setMessageType('success');
            setEvidenceCodeReadonly(true);
            loadRecord(discordId);
        } catch (error) {
            setMessage('Server-Fehler beim Speichern.');
            setMessageType('danger');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="dashboard-main">
            <div className="analyse-container">
                <div className="analyse-card">
                    <div className="analyse-header">
                        <div className="analyse-header-icon">
                            <i className="fas fa-flask"></i>
                        </div>
                        <h2>⚡ Analyse Bereich</h2>
                    </div>

                    <div className="analyse-body">
                        {message && (
                            <div className={`analyse-message ${messageType}`}>
                                {message}
                            </div>
                        )}

                        <div className="analyse-search">
                            <div className="analyse-search-row">
                                <label className="analyse-search-label">User-Discord ID:</label>
                                <div className="analyse-search-input-wrapper">
                                    <input
                                        type="text"
                                        className="analyse-search-input"
                                        placeholder="Discord ID eingeben..."
                                        value={discordId}
                                        onChange={handleDiscordIdChange}
                                    />
                                </div>
                                <div className={`analyse-status ${discordId.length >= 17 ? 'connected' : 'waiting'}`}>
                                    <span className="analyse-status-indicator"></span>
                                    STATUS: {discordId.length >= 17 ? 'VERBUNDEN' : 'Warte auf gültige Discord ID...'}
                                </div>
                            </div>
                        </div>

                        {discordId.length >= 17 && (
                            <div className="analyse-form-section">
                                <div className="analyse-guidelines-card">
                                    <div className="analyse-guidelines-header">
                                        <span className="analyse-guidelines-icon">⚡</span>
                                        <h4 className="analyse-guidelines-title">Wichtige Informationen & Analyse</h4>
                                    </div>
                                    <div className="analyse-guidelines-body">
                                        <div className="analyse-recording-section">
                                            <div 
                                                className={`analyse-recording-box ${recordingObligation ? 'active' : ''}`}
                                                onClick={() => setRecordingObligation(!recordingObligation)}
                                            >
                                                <input 
                                                    type="checkbox" 
                                                    className="analyse-recording-checkbox"
                                                    checked={recordingObligation} 
                                                    readOnly 
                                                />
                                                <label className="analyse-recording-label">Permanente Aufnahmepflicht</label>
                                            </div>
                                        </div>

                                        <form onSubmit={handleSubmit}>
                                            <div className="analyse-form-grid">
                                                <div className="analyse-form-group">
                                                    <label className="analyse-label">1. Analyse Ergebnis</label>
                                                    <select 
                                                        className="analyse-select" 
                                                        value={result} 
                                                        onChange={(e) => setResult(e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Status wählen...</option>
                                                        <option value="accepted">🟢 Bestanden</option>
                                                        <option value="modding">🔴 Modding erkannt</option>
                                                    </select>
                                                </div>

                                                <div className="analyse-form-group">
                                                    <label className="analyse-label">2. Gefundene Modifikationen</label>
                                                    <input 
                                                        type="text" 
                                                        className="analyse-input"
                                                        value={moddingPrograms} 
                                                        onChange={(e) => setModdingPrograms(e.target.value)} 
                                                        placeholder="z.B. Executor, Scripts, etc." 
                                                    />
                                                </div>

                                                <div className="analyse-form-group">
                                                    <label className="analyse-label">3. Eindeutiger Scan Code</label>
                                                    <input 
                                                        type="text" 
                                                        className="analyse-input"
                                                        value={evidenceCode} 
                                                        onChange={(e) => setEvidenceCode(e.target.value)} 
                                                        readOnly={evidenceCodeReadonly}
                                                        placeholder="Beweis Code eingeben..." 
                                                    />
                                                </div>

                                                <div className="analyse-form-group">
                                                    <label className="analyse-label">Dein abschließender Kommentar</label>
                                                    <textarea 
                                                        className="analyse-textarea"
                                                        value={comment} 
                                                        onChange={(e) => setComment(e.target.value)}
                                                        placeholder="Beschreibe hier kurz die Auffälligkeiten..."
                                                    />
                                                </div>
                                            </div>

                                            <div className="analyse-submit-section">
                                                <button 
                                                    type="submit" 
                                                    className="analyse-submit-btn"
                                                    disabled={loading}
                                                >
                                                    {loading ? '📡 ÜBERMITTLE DATEN...' : '✅ Analyse Speichern & Loggen'}
                                                </button>
                                            </div>
                                        </form>

                                        <div className="analyse-guidelines-list">
                                            <div className="analyse-guideline-item warning">
                                                <span className="analyse-guideline-icon">🔒</span>
                                                <div className="analyse-guideline-text">
                                                    <h6>Permanente Aufnahmepflicht !</h6>
                                                    <p>Wenn der Spieler eine Aufnahmepflicht bekommen soll, setzt einfach den "Haken" bei "Permanente Aufnahmepflicht".</p>
                                                    <p>Sollte die Aufnahmepflicht bereits als "Marked" sein, hat der Spieler bereits eine Aufnahmepflicht !</p>
                                                    <p>Aufnahmepflicht kann entzogen werden wenn, Ihr die Permanente Aufnahmepflicht "unmarked".</p>
                                                </div>
                                            </div>

                                            <div className="analyse-guideline-item info">
                                                <span className="analyse-guideline-icon">🔑</span>
                                                <div className="analyse-guideline-text">
                                                    <h6>Beweis Code validieren</h6>
                                                    <p>Der Code wird nach dem Speichern gesperrt. Prüfe den Code genau, bevor du speicherst.</p>
                                                </div>
                                            </div>

                                            <div className="analyse-guideline-item danger">
                                                <span className="analyse-guideline-icon">🔑</span>
                                                <div className="analyse-guideline-text">
                                                    <h6>Logging</h6>
                                                    <p>Jede änderung wird automatisch geloggt! Arbeitet gewissenhaft !</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Analyse;
